module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "c1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xpage"
  }, [_c('h4', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "href": "#/html/003_toc#c1_"
    }
  }, [_vm._v("ON ABORTION")])]), _vm._v(" "), _c('p', {
    staticClass: "textfirst"
  }, [_vm._v("I think the Democrats historically have made a mistake just trying to avoid the issue or pretend that there’s not a moral component to it. There is. I am pro-choice,\n    but I also think that it’s important—even as I indicate that I’m pro-choice—to say this is not a trivial issue. And we have to listen to the profound concerns that other\n    people have.")]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_c('em', [_vm._v("Face the Nation")]), _vm._v(", March 12, 2006")])]), _vm._v(" "), _c('div', {
    staticClass: "xpage"
  }, [_c('p', {
    staticClass: "textfirst2"
  }, [_vm._v("No one is pro-abortion.")]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_vm._v("Speech at Benedictine University, October 5, 2004")])]), _vm._v(" "), _c('div', {
    staticClass: "xpage"
  }, [_c('p', {
    staticClass: "textfirst2"
  }, [_vm._v("I don’t know anybody who is pro-abortion. I think it’s very important to start with that premise. I think people recognize what a wrenching, difficult issue it\n    is. Our goal should be to make abortion less common; that we should be discouraging unwanted pregnancies, that we should encourage adoption wherever possible.")]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_c('em', [_vm._v("Christianity Today")]), _vm._v(", January 2008")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d9b8ef0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/007_chap1.vue
// module id = 75
// module chunks = 0